import { FormInstance, message } from 'antd';
import { memo, useEffect, useState } from 'react';
import { Map, Marker } from '.';
import styles from './Map.module.less';
import { styled } from '@stitches/configed';

type Props = {
  form?: FormInstance;
  height?: number;

  initialPosition?: google.maps.LatLngLiteral | google.maps.LatLng;
  position?: google.maps.LatLngLiteral | google.maps.LatLng;

  disabled?: boolean;
  disableClick?: boolean;
  showButtonFindByAddress?: boolean;
  showButtonPanToCurrentPosition?: boolean;

  verifyAddress?: (address: string) => Promise<{ provinceId: number; districtId: number; address: string } | undefined>;
  onChangePosition?: (position?: google.maps.LatLngLiteral | google.maps.LatLng, address?: string | null) => void;
  setFormFromPlace?: (
    place: Partial<{
      name: string;
      provinceId: number;
      districtId: number;
      address: string;
      phone: string;
    }>,
  ) => void;
  onDisabledMaskClick?: () => void;
};
export const MapWithMarker = memo(
  ({
    form,
    height,

    initialPosition,
    position,

    disabled,
    disableClick,
    showButtonFindByAddress,
    showButtonPanToCurrentPosition,

    verifyAddress,
    onChangePosition,
    setFormFromPlace,
    onDisabledMaskClick,
  }: Props) => {
    const [clicks, setClicks] = useState<Array<google.maps.LatLngLiteral | google.maps.LatLng>>(
      initialPosition ? [initialPosition] : [],
    );
    const [zoom, setZoom] = useState(5);
    const [center, setCenter] = useState<google.maps.LatLngLiteral | google.maps.LatLng>(
      initialPosition || {
        lat: 15.8071716,
        lng: 105.3479606,
      },
    );

    const onClick = disableClick
      ? undefined
      : (
          e: google.maps.MapMouseEvent & { placeId?: string },
          // map: google.maps.Map,
          // infoWindow: google.maps.InfoWindow,
          // placesService: google.maps.places.PlacesService,
          // geocoder: google.maps.Geocoder,
        ) => {
          // avoid directly mutating state
          // e.latLng && setClicks([...clicks, e.latLng]); // for click multi position
          // const preClicks = clicks;
          e.latLng && setClicks([e.latLng]);

          // // place service
          // if (e.placeId && placesService) {
          //   placesService.getDetails({ placeId: e.placeId }, async (place) => {
          //     if (place && place.formatted_address) {
          //       if (verifyAddress) {
          //         const verifyResult = await verifyAddress(
          //           place.formatted_address.replace(' - ', '-'),
          //         );
          //         if (verifyResult) {
          //           setFormFromPlace &&
          //             setFormFromPlace({
          //               name: place.name,
          //               phone: place.formatted_phone_number?.replace(/ /g, ''),
          //               address: verifyResult.address.replace(' - ', '-'),
          //               provinceId: verifyResult.provinceId,
          //               districtId: verifyResult.districtId,
          //             });
          //           infoWindow.close();
          //         }
          //       }
          //     }
          //   });
          // } else {
          //   geocoder
          //     .geocode({ location: e.latLng })
          //     .then((response) => {
          //       const place = response.results[0];
          //       if (place) {
          //         infoWindow.setPosition(e.latLng);
          //         const infoHtml = document.createElement(`div`);
          //         infoHtml.classList.add(styles.infoWrapper);
          //         const addressDiv = document.createElement(`div`);
          //         addressDiv.textContent = place.formatted_address;
          //         const confirmButton = document.createElement('button');
          //         confirmButton.textContent = 'Xác nhận';
          //         confirmButton.classList.add(styles.confirmButton);
          //         confirmButton.addEventListener('click', async (e) => {
          //           e.preventDefault();
          //           if (verifyAddress) {
          //             const verifyResult = await verifyAddress(
          //               place.formatted_address.replace(' - ', '-'),
          //             );
          //             if (verifyResult) {
          //               setFormFromPlace &&
          //                 setFormFromPlace({
          //                   address: verifyResult.address.replace(' - ', '-'),
          //                   provinceId: verifyResult.provinceId,
          //                   districtId: verifyResult.districtId,
          //                 });
          //               infoWindow.close();
          //             }
          //           }
          //         });
          //         const cancelButton = document.createElement('button');
          //         cancelButton.textContent = 'Huỷ';
          //         cancelButton.classList.add(styles.cancelButton);
          //         cancelButton.addEventListener('click', () => {
          //           setClicks(preClicks);
          //           infoWindow.close();
          //         });
          //         const actionsDiv = document.createElement(`div`);
          //         infoHtml.appendChild(addressDiv);
          //         actionsDiv.appendChild(confirmButton);
          //         actionsDiv.appendChild(cancelButton);
          //         infoHtml.appendChild(actionsDiv);
          //         infoWindow.setContent(infoHtml);
          //         infoWindow.open(map);
          //       } else {
          //         message.error('Không tìm thấy địa chỉ tại vị trí đã chọn');
          //       }
          //     })
          //     .catch(() => {
          //       message.error('Lỗi dịch vụ Geocode');
          //     });
          // }
        };
    const onIdle = (_m: google.maps.Map) => {
      // disable map auto zoom and center when click
      // setZoom(m.getZoom() || zoom);
      // setCenter(m.getCenter()?.toJSON() || center);
    };

    const onGetCurrentPosition =
      showButtonPanToCurrentPosition && !disabled
        ? (map: google.maps.Map, infoWindow: google.maps.InfoWindow, geocoder: google.maps.Geocoder) => {
            // Try HTML5 geolocation.
            if (navigator.geolocation) {
              navigator.geolocation.getCurrentPosition(
                async (response: GeolocationPosition) => {
                  const position = {
                    lat: response.coords.latitude,
                    lng: response.coords.longitude,
                  };
                  try {
                    const response = await geocoder.geocode({
                      location: position,
                    });
                    if (response) {
                      const place = response.results[0];
                      if (place) {
                        const prePosition = {
                          lat: form?.getFieldValue('latitude'),
                          lng: form?.getFieldValue('longitude'),
                        };
                        setClicks([place.geometry.location]);
                        setCenter(place.geometry.location);
                        setZoom(15);
                        infoWindow.setPosition(place.geometry.location);
                        const infoHtml = document.createElement(`div`);
                        infoHtml.classList.add(styles.infoWrapper);
                        const addressDiv = document.createElement(`div`);
                        addressDiv.textContent = place.formatted_address;
                        const confirmButton = document.createElement('button');
                        confirmButton.textContent = 'Xác nhận';
                        confirmButton.classList.add(styles.confirmButton);
                        confirmButton.addEventListener('click', async (e) => {
                          e.preventDefault();
                          if (verifyAddress) {
                            const verifyResult = await verifyAddress(place.formatted_address.replace(' - ', '-'));
                            if (verifyResult) {
                              setFormFromPlace &&
                                setFormFromPlace({
                                  address: verifyResult.address.replace(' - ', '-'),
                                  provinceId: verifyResult.provinceId,
                                  districtId: verifyResult.districtId,
                                });
                              infoWindow.close();
                            }
                          }
                        });
                        const cancelButton = document.createElement('button');
                        cancelButton.textContent = 'Huỷ';
                        cancelButton.classList.add(styles.cancelButton);
                        cancelButton.addEventListener('click', () => {
                          setClicks([prePosition]);
                          map.setCenter(prePosition);
                          infoWindow.close();
                        });
                        const actionsDiv = document.createElement(`div`);
                        infoHtml.appendChild(addressDiv);
                        actionsDiv.appendChild(confirmButton);
                        actionsDiv.appendChild(cancelButton);
                        infoHtml.appendChild(actionsDiv);
                        infoWindow.setContent(infoHtml);
                        infoWindow.open(map);
                      } else {
                        message.error('Không tìm thấy địa chỉ tại vị trí đã chọn');
                      }
                    }
                  } catch (error) {
                    message.error('Lỗi dịch vụ Geocode');
                  }
                },
                () => {
                  const currentCenter = map.getCenter();
                  currentCenter &&
                    handleLocationError(map, currentCenter, infoWindow, 'Lỗi: Dịch vụ Geolocation thất bại.');
                },
              );
            } else {
              // Browser doesn't support Geolocation
              const currentCenter = map.getCenter();
              currentCenter &&
                handleLocationError(
                  map,
                  currentCenter,
                  infoWindow,
                  'Lỗi: Trình duyệt của bạn không hỗ trợ Geolocation.',
                );
            }
          }
        : undefined;

    const onFindByAddress =
      showButtonFindByAddress && !disabled
        ? async (map: google.maps.Map, infoWindow: google.maps.InfoWindow, geocoder: google.maps.Geocoder) => {
            const addressToSearch = form?.getFieldValue('addressToSearch');
            if (!addressToSearch) return;

            try {
              const response = await geocoder.geocode({
                address: addressToSearch,
              });
              if (response) {
                const place = response.results[0];
                if (place) {
                  const prePosition = {
                    lat: form?.getFieldValue('latitude'),
                    lng: form?.getFieldValue('longitude'),
                  };
                  setClicks([place.geometry.location]);
                  setCenter(place.geometry.location);
                  setZoom(15);
                  infoWindow.setPosition(place.geometry.location);
                  const infoHtml = document.createElement(`div`);
                  infoHtml.classList.add(styles.infoWrapper);
                  const addressDiv = document.createElement(`div`);
                  addressDiv.textContent = place.formatted_address;
                  const confirmButton = document.createElement('button');
                  confirmButton.textContent = 'Xác nhận';
                  confirmButton.classList.add(styles.confirmButton);
                  confirmButton.addEventListener('click', async (e) => {
                    e.preventDefault();
                    if (verifyAddress) {
                      const verifyResult = await verifyAddress(place.formatted_address.replace(' - ', '-'));
                      if (verifyResult) {
                        setFormFromPlace &&
                          setFormFromPlace({
                            address: verifyResult.address.replace(' - ', '-'),
                            provinceId: verifyResult.provinceId,
                            districtId: verifyResult.districtId,
                          });
                        infoWindow.close();
                      }
                    }
                  });
                  const cancelButton = document.createElement('button');
                  cancelButton.textContent = 'Huỷ';
                  cancelButton.classList.add(styles.cancelButton);
                  cancelButton.addEventListener('click', () => {
                    setClicks([prePosition]);
                    map.setCenter(prePosition);
                    infoWindow.close();
                  });
                  const actionsDiv = document.createElement(`div`);
                  infoHtml.appendChild(addressDiv);
                  actionsDiv.appendChild(confirmButton);
                  actionsDiv.appendChild(cancelButton);
                  infoHtml.appendChild(actionsDiv);
                  infoWindow.setContent(infoHtml);
                  infoWindow.open(map);
                } else {
                  message.error('Không tìm thấy địa chỉ tại vị trí đã chọn');
                }
              }
            } catch (error) {
              message.error('Lỗi dịch vụ Geocode');
            }
          }
        : undefined;

    useEffect(() => {
      if (position) {
        setClicks([position]);
        setCenter(position);
        // setZoom(15);
      }
    }, [position]);
    // init position (marker)
    useEffect(() => {
      if (initialPosition) {
        setZoom(15);
      }
    }, [initialPosition]);

    useEffect(() => {
      const asyncEffect = async () => {
        const lat = typeof clicks[0].lat === 'function' ? clicks[0].lat() : clicks[0].lat;
        const lng = typeof clicks[0].lng === 'function' ? clicks[0].lng() : clicks[0].lng;

        const address = (await getAddressFromLatLng(lat, lng)) as string | null;
        onChangePosition?.(clicks[0], address);
      };
      asyncEffect();
    }, [clicks, onChangePosition]);

    const MapDisabledMask = styled('div', {
      height: height || 156,
      zIndex: 1,
      inset: 0,
      position: 'absolute',
      cursor: 'pointer',
    });

    const getAddressFromLatLng = async (lat: number, lng: number) => {
      const geocoder = new google.maps.Geocoder();
      return new Promise((resolve, reject) => {
        geocoder.geocode({ location: { lat, lng } }, (results, status) => {
          if (status === 'OK' && results?.[0]) {
            resolve(results[0].formatted_address);
          } else {
            resolve(null); // return null if address not found
          }
        });
      });
    };

    return (
      <div style={{ position: 'relative' }}>
        <Map
          style={{ height: height || 400 }}
          center={center}
          onClick={onClick}
          onIdle={onIdle}
          zoom={zoom}
          onGetCurrentPosition={onGetCurrentPosition}
          onFindByAddress={onFindByAddress}
          form={form}
          disableDefaultUI={disabled}
        >
          {clicks.map((latLng, i) => (
            <Marker
              key={i}
              position={latLng}
              draggable
              onDragEnd={(marker) => {
                const position = marker.latLng;
                const lat = typeof position.lat === 'function' ? position.lat() : position.lat;

                const lng = typeof position.lng === 'function' ? position.lng() : position.lng;

                const currentPosition = clicks[0];
                const currentLat =
                  typeof currentPosition.lat === 'function' ? currentPosition.lat() : currentPosition.lat;

                const currentLng =
                  typeof currentPosition.lng === 'function' ? currentPosition.lng() : currentPosition.lng;
                if (currentLat !== lat || currentLng !== lng) {
                  setClicks([position]);
                }
              }}
            />
          ))}
        </Map>
        {disabled && <MapDisabledMask onClick={onDisabledMaskClick} />}
      </div>
    );
  },
);

const handleLocationError = (
  map: google.maps.Map,
  pos: google.maps.LatLng,
  infoWindow: google.maps.InfoWindow,
  message: string,
) => {
  const infoHtml = document.createElement(`div`);
  infoHtml.classList.add(styles.infoWrapper);

  const messageDiv = document.createElement(`div`);
  messageDiv.textContent = message;

  const confirmButton = document.createElement('button');
  confirmButton.textContent = 'Xác nhận';
  confirmButton.classList.add(styles.confirmButton);
  confirmButton.addEventListener('click', () => {
    map.setCenter(pos);
    infoWindow.close();
  });
  infoHtml.appendChild(messageDiv);
  infoHtml.appendChild(confirmButton);

  infoWindow.setPosition(pos);
  infoWindow.setContent(infoHtml);
  infoWindow.open(map);
};
